import { render, staticRenderFns } from "./counterCanbusValuesConfigsList.vue?vue&type=template&id=150fc896&scoped=true&"
import script from "./counterCanbusValuesConfigsList.vue?vue&type=script&lang=js&"
export * from "./counterCanbusValuesConfigsList.vue?vue&type=script&lang=js&"
import style0 from "./counterCanbusValuesConfigsList.vue?vue&type=style&index=0&id=150fc896&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "150fc896",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VDataTable,VRow})
